import { mirrorEasing } from './modifiers/mirror.mjs';
import { reverseEasing } from './modifiers/reverse.mjs';
const createBackIn = function () {
  let power = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.525;
  return p => p * p * ((power + 1) * p - power);
};
const backIn = createBackIn();
const backOut = reverseEasing(backIn);
const backInOut = mirrorEasing(backIn);
export { backIn, backInOut, backOut, createBackIn };